import styled from 'styled-components';

const PageContent = styled.div`
  display: grid;
  grid-gap: ${({ theme }) => theme.space[6]};
  padding-top: ${({ theme }) => theme.space[5]};
`;

export default { PageContent };
